import {Component, OnInit, Input} from '@angular/core';
import { CookieDisclaimerService } from '@signature-it/ngx-generic/services';

@Component({
    selector: 'cookie-disclaimer-type',
    templateUrl: './cookie-disclaimer-type.component.html',
    styleUrls: ['./cookie-disclaimer-type.component.scss'],
    standalone: false
})
export class CookieDisclaimerTypeComponent implements OnInit {

    @Input() title = '';
    @Input() type = '';
    @Input() description = '';
    // @Input() defaultValue = false;
    item: {type: string, value: boolean};

    constructor(protected cookieDisclaimerSvc: CookieDisclaimerService) {}

    ngOnInit() {
        this.item = {
            type:this.type,
            value:this.type == 'generic' ? true : this.cookieDisclaimerSvc.getCookieDisclaimer(this.type)
        };
        this.cookieDisclaimerSvc.statusTypeArray.push(this.item);
    }

    onSlideChange(e) {
        this.item.value = e.checked;
    }
}

